// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2727":"7a561cff","4880":"7a561cff","7419":"7a561cff","8084":"7a561cff","9282":"7a561cff"}[chunkId] + ".chunk.css";
};